"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardIcon = void 0;
var _react = require("react");
var _Button = require("../Button");
var _Card = require("../Card");
var _Icon = require("../Icon");
var _Typography = require("../Typography");
var _helpers = require("../../common/helpers");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["icon", "button", "heading", "description", "slots", "slotProps", "className"];
/**
 * Card Icon - [API](https://reimagined-adventure-37999z9.pages.github.io/?path=/docs/surfaces-cardicon--docs)
 *
 * @example
 *
 * <CardIcon
 *   heading="Coronado Hospital Foundation"
 *   description="Supports the health care needs"
 *   icon="mobile"
 *   button={{ label: 'Learn more' }}
 * />
 */
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var CardIcon = exports.CardIcon = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _slots$buttonContaine, _slots$button;
  var icon = _ref.icon,
    button = _ref.button,
    heading = _ref.heading,
    description = _ref.description,
    _ref$slots = _ref.slots,
    slots = _ref$slots === void 0 ? {} : _ref$slots,
    _ref$slotProps = _ref.slotProps,
    slotProps = _ref$slotProps === void 0 ? {} : _ref$slotProps,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var ButtonContainer = (_slots$buttonContaine = slots.buttonContainer) !== null && _slots$buttonContaine !== void 0 ? _slots$buttonContaine : _react.Fragment;
  var ButtonComponent = (_slots$button = slots.button) !== null && _slots$button !== void 0 ? _slots$button : _Button.Button;
  var buttonComponentProps = slots.button ? slotProps.button : _objectSpread(_objectSpread({
    width: 'full',
    size: 'sm'
  }, button), slotProps.button);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Card.Card, _objectSpread(_objectSpread({
    ref: ref,
    variant: "filled",
    className: (0, _helpers.cn)('flex', 'flex-col', 'gap-6', className)
  }, props), {}, {
    children: [icon && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _helpers.cn)('flex', 'items-center', 'justify-center', 'bg-primary-50', 'h-[68px]', 'w-[68px]', 'rounded-full', '-mt-15'),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        icon: ['fad', icon],
        className: "text-primary",
        fontSize: 28
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "space-y-2 flex-grow",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.Typography, {
        variant: "h4",
        as: "h3",
        lineClamp: 2,
        children: heading
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.Typography, {
        className: "scl-rich-text",
        children: description
      })]
    }), (button || slots.button) && /*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonContainer, _objectSpread(_objectSpread({}, slotProps.buttonContainer), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonComponent, _objectSpread({}, buttonComponentProps))
    }))]
  }));
});